// extracted by mini-css-extract-plugin
module.exports = {"container":"Table_container__1buGw","marginTop":"Table_marginTop__1PZNL","tableContainer":"Table_tableContainer__3-3XW"};